import React, { Component } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";

import ForgotPage from "../../components/authentication/ForgotPage";
import * as authActions from "../../state/actions/authActions.js";

class ForgotContainer extends Component {
    render() {
        const { changeValue, forgot, ...props } = this.props;
        const { email, history } = props;

        return (
            <ForgotPage
                {...props}
                onChange={changeValue}
                onForgot={() => {
                    forgot(email).then(() => {
                        history.push("/");
                    });
                }}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        error: state.auth.error,
        email: state.auth.email,
        isFetching: state.auth.isFetching,
        isAuthenticated: state.auth.isAuthenticated,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        forgot: (email) => dispatch(authActions.forgot(email)),
        changeValue: (name, value) => dispatch(authActions.changeForgotValue(name, value)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation("translation")(ForgotContainer));
